import { FormWithRedux } from '../../FormWithRedux';
import { GallbladderInformationForm } from  './Gallbladder-InformationForm';

export class GallbladderIntroForm extends FormWithRedux {

    constructor() {
        super('introForm');
    }

    generateSubform(identifier) {
        switch (identifier) {
            case 'PathwayInformationForm':
                return new GallbladderInformationForm();
        }
    }

    shouldDisplayFormDetailForIdentifier(identifier) {
        super.shouldDisplayFormDetailForIdentifier(identifier);

        return true;
    }

    isEnabled(identifier) {
        if (identifier != null) {
            return true;
        }
        return false;
    }

    isMandatory() {
        return false;
    }

    getValueType() {
        return null;
    }

    submissionValidation() {
        return [];
    }

    detailString() {
        return this.detail;
    }
}


// WEBPACK FOOTER //
// ./src/forms/Gallbladder01/IntroForm/Gallbladder-IntroForm.js